<template>
<div>
    <v-row class="ma-2" align="center">
        <v-col class="my-0 py-0" cols="12" sm="2">
            <span style="color: #3498db; font-weight: bold">자산 {{ index + 1 }}</span>
            <v-btn icon small @click="$emit('delete')">
                <v-icon>delete</v-icon>
            </v-btn>
        </v-col>
        <v-col class="py-1" cols="12" sm="7">
            <v-text-field :value="assetText" :loading="isLoading" solo append-icon="search" placeholder="자산 검색 및 설정" readonly hide-details @click="showDialog" />
        </v-col>
        <v-col class="py-1" cols="12" sm="3">
            <v-text-field v-model="asset.percent" solo hide-details type="number" suffix="%" />
        </v-col>
    </v-row>

    <v-dialog v-model="dialog" scrollable max-width="500">
        <v-card>
            <v-card-title style="background: #3498db; color: white"><b>자산 검색</b></v-card-title>
            <div class="pa-3 pb-0">
                <v-select v-model="sort" :items="sorts" item-value="id" label="종류" item-text="name" solo @change="sortChanged" />
                <v-text-field v-model="searchText" :loading="isLoading" solo append-icon="search" placeholder="검색" :hint="hintMessage" @click:append="firstFind" @keyup.enter="firstFind" />
            </div>
            <v-card-text class="px-3">
                <v-card class="px-2">
                    <v-list v-if="searchResult.length > 0">
                        <v-list-item-group v-model="selectedAsset" color="primary">
                            <v-list-item class="ma-0" v-for="(result, i) in searchResult" :key="result.code">
                                <v-list-item-title>{{ assetFormat(result) }}</v-list-item-title>
                                <v-list-item-icon v-if="selectedAsset == i">
                                    <v-icon color="primary">done</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                        </v-list-item-group>
                        <div class="text-center" v-show="isMore">
                            <v-btn text color="primary" @click="findMore">더 보기</v-btn>
                        </div>
                    </v-list>
                    <v-row class="pa-2" justify="center" v-else>
                        검색된 자산이 없습니다
                    </v-row>
                </v-card>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="setAsset">설 정</v-btn>
                <v-btn color="red" @click="dialog = false">닫 기</v-btn>
                <v-spacer />
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
    name: 'asset-item',
    props: [
        'index', 'asset'
    ],
    data() {
        return {
            assetText: '',
            sorts: [{
                id: '',
                name: '현 금'
            }, {
                id: 'krstockprice',
                name: '국내주식'
            }, {
                id: 'kretfprice',
                name: '국내ETF'
            }, {
                id: 'usetfprice',
                name: '미국ETF'
            }],
            dialog: false,
            sort: '',
            searchText: '',
            searchResult: [],
            page: 0,
            selectedAsset: null,
            isLoading: false,
            isMore: false,
        }
    },
    computed: {
        hintMessage() {
            switch (this.sort) {
                case 'krstockprice':
                    return 'Ex) 삼성, LG, SK 등'
                case 'kretf':
                    return 'Ex) KODEX, TIGER, 골드 등'
                case 'usetf':
                    return 'Ex) SPY, VTI, IAU 등'
                default:
                    return ''
            }
        }
    },
    watch: {},
    async mounted() {
        this.assetText = this.assetFormat(this.asset)
    },
    methods: {
        showDialog() {
            this.searchText = ''
            this.searchResult = []
            this.sort = null
            this.selectedAsset = null
            this.page = 0
            this.isMore = false
            this.dialog = true
        },
        async firstFind() {
            if (!this.validate()) return

            this.page = 0
            this.searchResult = []
            this.findAsset()
        },
        async findMore() {
            if (!this.validate()) return

            this.page++
            this.findAsset()
        },
        async findAsset() {
            try {
                console.log(this.searchText.replace(/\s/g, ''))
                this.isLoading = true
                const localSort = this.sort
                const result = await this.$http.get('/find/asset', {
                    params: {
                        sort: this.sort,
                        text: this.searchText.replace(/\s/g, ''),
                        page: this.page
                    }
                })

                this.isMore = result.data.length >= 20

                for (const asset of result.data) {
                    asset.percent = 0
                    asset.sort = localSort
                    this.searchResult.push(asset)
                }
            } catch (e) {
                this.$toasted.error('검색 도중 오류가 발생했습니다')
                this.$http.post('/report-error', {stack: e.stack})
            } finally {
                this.isLoading = false
            }
        },
        setAsset() {
            if (this.selectedAsset == null) return this.$toasted.error('선택된 자산이 없습니다')

            const newAsset = this.searchResult[this.selectedAsset]
            this.assetText = this.assetFormat(newAsset)
            this.$emit('set', newAsset)
            this.dialog = false
        },
        sortChanged() {
            switch (this.sort) {
                case '':
                    this.searchResult = [{
                        name: '현 금',
                        code: '000000',
                        min: '',
                        max: '',
                        percent: 0,
                    }]
                    break
                default:
                    this.searchResult = []
                    break
                
            }
        },
        assetFormat(result) {
            if (!result.name) return ''

            let str = `${result.name} (${result.code})`

            if (result.min) {
                str += ` / ${result.min} ~ ${result.max}`
            }

            return str
        },
        validate() {
            if (this.sort == null) {
                this.$toasted.error('자산 종류를 선택해주세요')
                return false
            }

            if (this.sort == '') return false

            if (this.searchText.replace(/\s/g, '') == '') {
                this.$toasted.error('검색어를 입력해주세요')
                return false
            }

            return true
        }
    }
}
</script>
